// extracted by mini-css-extract-plugin
export default {"solutions":"styles_solutions__W31Gz"};